// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroVideo_wrapper__3XMLv","content":"HeroVideo_content__1PAmv","subtitle":"HeroVideo_subtitle__ZeyUa","video":"HeroVideo_video__1blk6","fadeIn":"HeroVideo_fadeIn__1Uf_G"};